import Axios from "axios";

const apiDev = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
});

const apiProd = Axios.create({
  baseURL: process.env.REACT_APP_PROD_API_URL,
  timeout: 10000,
});

export { apiDev, apiProd };
